import React from 'react';
import { TextFooter } from '../../styles/footerStyled/footerStyled';

export const Footer = () => {
  return (
    <>
      <TextFooter>Copyright By Casandra - 2023</TextFooter>
    </>
  );
};
